module.exports = __webpack_public_path__ + "img/link-pocket-desktop_jp.4ece516.jpg";